const isInpostDelivery = ({
  deliveryDetailKey,
  carrierCode,
  shippingAddress,
} = {}) => {
  const haystack = [
    deliveryDetailKey,
    carrierCode,
    shippingAddress?.addressLine1,
    shippingAddress?.addressLine2,
    shippingAddress?.addressLine3,
  ]
    .filter(Boolean)
    .join(' ');

  return /inpost/i.test(haystack);
};

export default isInpostDelivery;
